<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table
        :data="tableData"
        v-loading="listLoading"
        @selection-change="onSelectionChange"
        @row-click="selectCurrentRow"
        ref="table"
        class="custom-tbl"
        height="100%" style="width: 100%"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="studentName" label="学生姓名" width="100"></el-table-column>
        <el-table-column prop="studentNo" label="学号" width="120"></el-table-column>
        <el-table-column prop="cardNumber" label="卡号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="honorTitle" label="表彰称号" min-width="160"></el-table-column>
        <el-table-column prop="semesterName" label="学期" width="160"></el-table-column>
        <el-table-column prop="sourceName" label="来源" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.source === 2 ? 'warning' : 'success'" size="small">
              {{ scope.row.source === 2 ? '班主任添加' : '后台导入' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createBy" label="创建人" width="100"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"
          :formatter="(row) => formatDate(row.createTime)"></el-table-column>
      </el-table>
      </div>

      <!--分页-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="total"
          style="float: right"
        ></el-pagination>
      </el-col>

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        :title="editForm.id ? '编辑表彰称号' : '新增表彰称号'"
        :visible.sync="editFormVisible"
        :close-on-click-modal="false"
        width="560px"
      >
        <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="90px">
          <el-form-item label="学期" prop="semesterId">
            <el-select v-model="editForm.semesterId" placeholder="请选择学期" style="width: 100%">
              <el-option
                v-for="item in semesterOptions"
                :key="item.Id || item.id"
                :label="item.SemesterName || item.semesterName"
                :value="item.Id || item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="editCampusOptions.length > 1" label="校区">
            <el-select
              v-model="editForm.campusId"
              placeholder="请选择校区"
              clearable
              filterable
              style="width: 100%"
              @change="onEditCampusChange"
            >
              <el-option
                v-for="item in editCampusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="editGradeOptions.length" label="年级" prop="gradeId">
            <el-select
              v-model="editForm.gradeId"
              placeholder="请选择年级"
              clearable
              filterable
              style="width: 100%"
              @change="onEditGradeChange"
            >
              <el-option
                v-for="item in editGradeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级" prop="classDepartmentId">
            <el-select
              v-model="editForm.classDepartmentId"
              placeholder="请选择班级"
              clearable
              filterable
              style="width: 100%"
              @change="onEditClassChange"
            >
              <el-option
                v-for="item in editClassOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学生" prop="studentInfoId">
            <el-select
              v-model="editForm.studentInfoId"
              placeholder="请先选择学生"
              filterable
              :disabled="!editForm.classDepartmentId"
              :loading="editStudentLoading"
              style="width: 100%"
            >
              <el-option
                v-for="s in editStudentOptions"
                :key="s.id"
                :label="s.stuName + (s.stuCode ? '（' + s.stuCode + '）' : '')"
                :value="s.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="表彰称号" prop="honorTitle">
            <el-select
              v-model="editForm.honorTitle"
              filterable
              allow-create
              default-first-option
              clearable
              placeholder="请选择常用称号，也可直接输入"
              style="width: 100%"
            >
              <el-option
                v-for="item in honorTitlePresets"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.remark" maxlength="500" show-word-limit :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click="submitEdit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 批量导入弹窗：选学期 → 下载模板 → 上传文件 → 预览确认 -->
      <el-dialog
        title="批量导入表彰称号"
        :visible.sync="importDialogVisible"
        width="55%"
        :close-on-click-modal="false"
        append-to-body
        @closed="resetImportDialog"
      >
        <el-form label-width="72px" style="margin-bottom: 12px;">
          <el-form-item label="学期" required>
            <el-select v-model="importSemesterId" placeholder="请选择导入学期" style="width: 100%">
              <el-option
                v-for="item in semesterOptions"
                :key="item.Id || item.id"
                :label="item.SemesterName || item.semesterName"
                :value="item.Id || item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属班级">
            <el-input :value="currentDeptName || '（请先在左侧选择班级）'" disabled></el-input>
          </el-form-item>
        </el-form>

        <el-tabs v-model="importActiveTab" type="border-card" class="import-tabs">
          <el-tab-pane label="① 下载模板" name="download">
            <div class="import-tab-pane">
              <div class="import-download-box">
                <i class="el-icon-document import-download-icon"></i>
                <p class="import-tip">模板将自动带出本班全部学生，只需在 <b>表彰称号</b> 列填写内容即可，备注可选。</p>
                <p class="import-tip-sub">请勿修改「学生ID」「学生姓名」列，以免导入匹配失败。</p>
                <el-button
                  type="primary"
                  icon="el-icon-download"
                  :disabled="!importSemesterId"
                  :loading="importTemplateLoading"
                  @click="downloadImportTemplate"
                >下载导入模板</el-button>
              </div>
              <div class="import-step-tip">
                <i class="el-icon-info"></i>
                <span>填写完成后，切换到「上传文件」页签导入。</span>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="② 上传文件" name="upload" :disabled="!importSemesterId">
            <div class="import-tab-pane">
              <el-upload
                ref="importUpload"
                action=""
                drag
                :auto-upload="false"
                :limit="1"
                accept=".xls,.xlsx"
                :on-change="onImportFileChange"
                :on-remove="onImportFileRemove"
                :file-list="importFileList"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将填写好的 Excel 拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持 .xls / .xlsx，表头：学生ID、学生姓名、表彰称号、备注（仅填表彰称号列即可）</div>
              </el-upload>
            </div>
          </el-tab-pane>

          <el-tab-pane label="③ 预览确认" name="preview" :disabled="!importOutputs.length">
            <div class="import-tab-pane">
              <p class="import-preview-summary">共解析 <b>{{ importOutputs.length }}</b> 条，确认无误后点击「确认导入」。</p>
              <el-table :data="importOutputsPage" max-height="360" size="small" border>
                <el-table-column type="index" label="序号" width="55"
                  :index="(idx) => (importPreviewPage - 1) * importPreviewPageSize + idx + 1"></el-table-column>
                <el-table-column prop="studentInfoId" label="学生ID" width="150"></el-table-column>
                <el-table-column prop="studentName" label="学生姓名" width="100"></el-table-column>
                <el-table-column prop="honorTitle" label="表彰称号" min-width="140"></el-table-column>
                <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
                <el-table-column label="操作" width="70" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" style="color: #F56C6C" @click="removeImportRow(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                v-if="importOutputs.length > importPreviewPageSize"
                class="import-preview-pagination"
                layout="total, sizes, prev, pager, next"
                :current-page.sync="importPreviewPage"
                :page-size.sync="importPreviewPageSize"
                :page-sizes="[20, 50, 100]"
                :total="importOutputs.length"
                @current-change="handleImportPreviewPageChange"
                @size-change="handleImportPreviewSizeChange"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div slot="footer" class="dialog-footer">
          <el-button @click="importDialogVisible = false">取消</el-button>
          <el-button
            v-if="importActiveTab === 'download' && importSemesterId"
            type="primary"
            plain
            @click="importActiveTab = 'upload'"
          >下一步：上传文件</el-button>
          <el-button
            v-if="importActiveTab === 'preview' && importOutputs.length"
            type="primary"
            :loading="importLoading"
            @click="submitImport"
          >确认导入</el-button>
        </div>
      </el-dialog>

      <!-- 导入结果弹窗 -->
      <el-dialog title="导入结果" :visible.sync="importResultVisible" width="520px" append-to-body>
        <div style="text-align: center; margin-bottom: 12px;">
          <i
            :class="importResult.failCount === 0 ? 'el-icon-success' : 'el-icon-warning'"
            :style="{ fontSize: '40px', color: importResult.failCount === 0 ? '#67C23A' : '#E6A23C' }"
          ></i>
          <p style="font-size: 16px; margin: 8px 0 4px;">
            成功 <b style="color: #67C23A">{{ importResult.successCount }}</b> 条，
            失败 <b style="color: #F56C6C">{{ importResult.failCount }}</b> 条
          </p>
        </div>
        <div v-if="importResult.failReasons && importResult.failReasons.length > 0">
          <p style="margin-bottom: 6px; font-weight: 600;">失败原因：</p>
          <ul style="max-height: 220px; overflow-y: auto; padding-left: 18px;">
            <li v-for="(reason, idx) in importResult.failReasons" :key="idx" style="margin-bottom: 4px; color: #F56C6C;">
              {{ reason }}
            </li>
          </ul>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="importResultVisible = false">确定</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { read, utils, writeFile } from 'xlsx';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';
import { resolveHomeVisitSchoolIdFromTreeNode } from '../../api/homeVisit';
import { getStudentHonorTitlePage, addStudentHonorTitle, editStudentHonorTitle, deleteStudentHonorTitle, deleteStudentHonorTitleBatch, importStudentHonorTitleBatch, getStudentHonorTitleSemesters, getStudentInfoListPage } from '../../api/modules/personnel';
import { getSubDepartmentList } from '../../api/modules/department';
import { normalizeDeptId, deptIdsEqual } from '../../utils/deptCascaderProps';

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      // 搜索栏配置
      searchList: [
        {
          label: '学期',
          key: 'semesterId',
          type: 'select',
          clearable: true,
          options: [],
        },
        {
          label: '姓名/称号',
          key: 'keyword',
        },
      ],
      // 权限按钮
      buttonList: [],
      // 列表
      tableData: [],
      listLoading: false,
      total: 0,
      page: 1,
      pageSize: 10,
      filters: {},
      currentRow: null,
      sels: [],
      // 部门
      DepartmentId: 0,
      SchoolDepartmentId: 0,
      currentDeptName: '',
      selectedTreeNode: null,
      // 新增/编辑弹窗 — 部门级联
      editDeptList: [],
      editDeptMap: {},
      editDeptLoadedForSchool: 0,
      editCampusOptions: [],
      editGradeOptions: [],
      editClassOptions: [],
      editStudentOptions: [],
      editStudentLoading: false,
      // 学期选项
      semesterOptions: [],
      // 新增/编辑弹窗
      editFormVisible: false,
      editLoading: false,
      editForm: {
        id: null,
        semesterId: null,
        campusId: null,
        gradeId: null,
        classDepartmentId: null,
        studentInfoId: null,
        honorTitle: '',
        remark: '',
      },
      editFormRules: {
        semesterId: [{ required: true, message: '请选择学期', trigger: 'change' }],
        gradeId: [{
          validator: (rule, value, callback) => {
            if (this.editGradeOptions.length > 0 && !value) {
              callback(new Error('请选择年级'));
            } else {
              callback();
            }
          },
          trigger: 'change',
        }],
        classDepartmentId: [{ required: true, message: '请选择班级', trigger: 'change' }],
        studentInfoId: [{ required: true, message: '请选择学生', trigger: 'change' }],
        honorTitle: [
          { required: true, message: '称号不能为空', trigger: ['blur', 'change'] },
          { max: 200, message: '称号最多200字', trigger: ['blur', 'change'] },
        ],
      },
      // 常用表彰称号预设，支持下拉选择也可自行输入。最后更新：2026-08-30
      honorTitlePresets: [
        '三好学生',
        '优秀班干部',
        '优秀学生干部',
        '学习标兵',
        '进步之星',
        '文明学生',
        '纪律标兵',
        '劳动之星',
        '体育之星',
        '文艺之星',
        '优秀团员',
        '优秀少先队员',
      ],
      // 导入相关
      importDialogVisible: false,
      importActiveTab: 'download',
      importOutputs: [],
      importPreviewPage: 1,
      importPreviewPageSize: 20,
      importSemesterId: null,
      importFileList: [],
      importTemplateLoading: false,
      importLoading: false,
      // 导入结果
      importResultVisible: false,
      importResult: { successCount: 0, failCount: 0, failReasons: [] },
    };
  },
  computed: {
    /** 导入预览当前页数据 */
    importOutputsPage() {
      const start = (this.importPreviewPage - 1) * this.importPreviewPageSize;
      return this.importOutputs.slice(start, start + this.importPreviewPageSize);
    },
  },
  mounted() {
    this.initButtons();
  },
  methods: {
    /** 初始化工具栏按钮（与 Users.vue / HomeVisit 页面一致） */
    initButtons() {
      const routePath = this.$route.path;
      let routers = [];
      try {
        routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
      } catch (e) {
        console.error('[StudentHonorTitle] localStorage.router 解析失败', e);
      }

      const rawButtons = getButtonList(routePath, routers);
      // 按钮在菜单里常标记为隐藏，但 Toolbar 用 !IsHide 控制显示，此处强制显示
      this.buttonList = (rawButtons || []).map((item) => ({
        ...item,
        Func: item.Func || item.func,
        name: item.name || item.Name,
        IsHide: false,
      }));

      console.group('[StudentHonorTitle] 按钮权限调试');
      console.log('当前路由 path:', routePath);
      console.log('localStorage.router 节点数:', routers.length);
      console.log('getButtonList 原始结果:', rawButtons);
      console.log('最终 buttonList:', this.buttonList);
      this.logRouterTreeForMatch(routers, routePath);
      if (!this.buttonList.length) {
        console.warn(
          '[StudentHonorTitle] 未匹配到按钮，请检查：1) 菜单 Code 是否为 /User/StudentHonorTitle；2) 按钮 Pid 是否挂在该菜单下；3) 角色是否已勾选按钮权限；4) 是否已清除 localStorage.router 并重新登录'
        );
      }
      console.groupEnd();
    },
    /** 调试：在路由树中查找与当前 path 匹配的节点 */
    logRouterTreeForMatch(routers, routePath) {
      const target = (routePath || '').toLowerCase();
      const walk = (nodes, depth = 0) => {
        if (!nodes || !nodes.length) return;
        nodes.forEach((node) => {
          const path = (node.path || '').toLowerCase();
          const matched = path === target;
          const prefix = '  '.repeat(depth);
          console.log(
            `${prefix}${matched ? '>>> ' : ''}${node.name || node.Name || '(无name)'} | path=${node.path} | children=${(node.children || []).length}`
          );
          if (matched && node.children) {
            console.log(`${prefix}  匹配节点的 children(按钮):`, node.children);
          }
          if (node.children && node.children.length) {
            walk(node.children, depth + 1);
          }
        });
      };
      console.log('[StudentHonorTitle] 路由树遍历:');
      walk(routers);
    },
    // 部门树点击
    treeNodeClick(data, node) {
      this.DepartmentId = data.value;
      this.currentDeptName = data.label;
      this.selectedTreeNode = { data, node };
      // 通过 el-tree node 的父链向上找到学校根部门，与 HomeVisit 模块保持一致
      const prevSchoolId = this.SchoolDepartmentId;
      this.SchoolDepartmentId = resolveHomeVisitSchoolIdFromTreeNode(node, data.value);
      if (prevSchoolId !== this.SchoolDepartmentId) {
        this.editDeptLoadedForSchool = 0;
        this.editDeptList = [];
        this.resetSemesterFilter();
      }
      console.log('[StudentHonorTitle] treeNodeClick', {
        deptId: this.DepartmentId,
        deptName: this.currentDeptName,
        schoolDepartmentId: this.SchoolDepartmentId,
        nodeData: data,
      });
      this.page = 1;
      this.loadSemesters();
      this.handleQuery();
    },
    // Toolbar 分发
    callFunction(item) {
      this.filters = typeof item.search === 'object' ? item.search : { keyword: item.search };
      this[item.Func] && this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    onSelectionChange(selection) {
      this.sels = selection || [];
    },
    selectCurrentRow(row, column) {
      if (!this.$refs.table || !row) return;
      // 点击复选框列时由 el-table 自身处理，避免重复切换
      if (column && column.type === 'selection') return;
      this.currentRow = row;
      this.$refs.table.toggleRowSelection(row);
    },
    /** 切换学校时清空工具栏学期筛选与本地 filters */
    resetSemesterFilter() {
      this.semesterOptions = [];
      const semesterFilter = this.searchList.find((s) => s.key === 'semesterId');
      if (semesterFilter) {
        this.$set(semesterFilter, 'options', []);
      }
      if (this.filters && this.filters.semesterId != null) {
        this.$delete(this.filters, 'semesterId');
      }
      const toolbar = this.$refs.toolbar;
      if (toolbar && toolbar.searchObj) {
        this.$set(toolbar.searchObj, 'semesterId', null);
      }
    },
    // 加载学期下拉选项
    loadSemesters() {
      if (!this.SchoolDepartmentId) {
        console.warn('[StudentHonorTitle] loadSemesters 跳过：SchoolDepartmentId 为空');
        return;
      }
      const schoolId = this.SchoolDepartmentId;
      console.log('[StudentHonorTitle] loadSemesters 请求', { schoolDepartmentId: schoolId });
      getStudentHonorTitleSemesters({ schoolDepartmentId: schoolId }).then((res) => {
        if (schoolId !== this.SchoolDepartmentId) return;
        console.log('[StudentHonorTitle] loadSemesters 响应', res.data);
        if (res.data.success) {
          this.semesterOptions = res.data.response || [];
          // 同步到 searchList 学期下拉
          const semesterFilter = this.searchList.find((s) => s.key === 'semesterId');
          if (semesterFilter) {
            // 后端序列化可能返回 SemesterName（PascalCase）或 semesterName（camelCase），兼容两种
            const options = this.semesterOptions.map((s) => ({
              label: s.SemesterName || s.semesterName,
              value: s.Id || s.id,
            }));
            this.$set(semesterFilter, 'options', options);
            console.log('[StudentHonorTitle] 学期下拉 options', options);
          }
        }
      });
    },
    // 查询列表
    handleQuery() {
      this.listLoading = true;
      const para = this.buildListQueryParams();
      getStudentHonorTitlePage(para)
        .then((res) => {
          if (res.data.success) {
            const resp = res.data.response || {};
            this.total = resp.dataCount != null ? resp.dataCount : (resp.DataCount || 0);
            const rows = resp.data || resp.Data || [];
            this.tableData = rows.map((row) => this.normalizeHonorTitleRow(row));
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /** 列表行字段兼容 PascalCase / camelCase */
    normalizeHonorTitleRow(row) {
      if (!row) return {};
      return {
        id: row.id != null ? row.id : row.Id,
        departmentId: row.departmentId != null ? row.departmentId : row.DepartmentId,
        studentInfoId: row.studentInfoId != null ? row.studentInfoId : row.StudentInfoId,
        studentName: row.studentName || row.StudentName || '',
        studentNo: row.studentNo || row.StudentNo || '',
        cardNumber: row.cardNumber || row.CardNumber || '',
        semesterId: row.semesterId != null ? row.semesterId : row.SemesterId,
        semesterName: row.semesterName || row.SemesterName || '',
        honorTitle: row.honorTitle || row.HonorTitle || '',
        source: row.source != null ? row.source : row.Source,
        remark: row.remark || row.Remark || '',
        createBy: row.createBy || row.CreateBy || '',
        createTime: row.createTime || row.CreateTime,
      };
    },
    /** 组装列表查询参数，过滤空值避免后端 long 绑定失败 */
    buildListQueryParams() {
      const para = {
        page: this.page,
        pageSize: this.pageSize,
        departmentId: this.DepartmentId,
        schoolDepartmentId: this.SchoolDepartmentId,
        ...this.filters,
      };
      if (!para.semesterId) delete para.semesterId;
      if (!para.keyword) delete para.keyword;
      return para;
    },
    // 新增
    async handleAdd() {
      if (!this.SchoolDepartmentId) {
        this.$message.warning('请先在左侧选择学校/校区/年级/班级');
        return;
      }
      this.editForm = {
        id: null,
        semesterId: null,
        campusId: null,
        gradeId: null,
        classDepartmentId: null,
        studentInfoId: null,
        honorTitle: '',
        remark: '',
      };
      this.editStudentOptions = [];
      this.editFormVisible = true;
      await this.initEditFormFromTree();
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
    },
    // 编辑
    async handleEdit() {
      const row = this.currentRow || (this.sels.length === 1 ? this.sels[0] : null);
      if (!row) {
        this.$message.warning('请先选择一条记录');
        return;
      }
      // 统一转 Number，避免与 el-option value 类型不一致导致班级/学生无法回显
      const classId = row.departmentId != null ? Number(row.departmentId) : null;
      const studentId = row.studentInfoId != null ? Number(row.studentInfoId) : null;
      const semesterId = row.semesterId != null ? Number(row.semesterId) : null;
      this.editForm = {
        id: row.id,
        semesterId,
        campusId: null,
        gradeId: null,
        classDepartmentId: classId,
        studentInfoId: studentId,
        honorTitle: row.honorTitle || '',
        remark: row.remark || '',
      };
      this.editStudentOptions = [];
      this.editFormVisible = true;
      await this.ensureEditDeptList();
      await this.syncEditCascadeFromClassId(classId);
      await this.loadEditStudents(classId);
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
    },
    // 删除（支持批量）
    handleDel() {
      const rows = this.sels.length
        ? this.sels
        : (this.currentRow ? [this.currentRow] : []);
      if (!rows.length) {
        this.$message.warning('请先选择要删除的记录');
        return;
      }
      const ids = rows.map((r) => r.id).filter((id) => id);
      if (!ids.length) {
        this.$message.warning('所选记录无效');
        return;
      }
      const confirmMsg = ids.length === 1
        ? '确认删除该条表彰称号？'
        : `确认删除选中的 ${ids.length} 条表彰称号？`;
      this.$confirm(confirmMsg, '提示', { type: 'warning' }).then(() => {
        this.listLoading = true;
        const request = ids.length === 1
          ? deleteStudentHonorTitle({ id: ids[0] })
          : deleteStudentHonorTitleBatch(ids);
        request
          .then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.msg || '删除成功');
              this.sels = [];
              this.currentRow = null;
              if (this.$refs.table) this.$refs.table.clearSelection();
              this.handleQuery();
            } else {
              this.$message.error(res.data.msg || '删除失败');
            }
          })
          .finally(() => {
            this.listLoading = false;
          });
      });
    },
    // 提交新增/编辑
    submitEdit() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.editLoading = true;
        const params = {
          id: this.editForm.id,
          schoolDepartmentId: this.SchoolDepartmentId,
          departmentId: this.editForm.classDepartmentId,
          studentInfoId: this.editForm.studentInfoId,
          semesterId: this.editForm.semesterId,
          honorTitle: this.editForm.honorTitle,
          remark: this.editForm.remark,
        };
        const request = this.editForm.id
          ? editStudentHonorTitle(this.editForm.id, params)
          : addStudentHonorTitle(params);
        request
          .then((res) => {
            if (res.data.success) {
              this.$message.success(this.editForm.id ? '编辑成功' : '新增成功');
              this.editFormVisible = false;
              this.handleQuery();
            } else {
              this.$message.error(res.data.msg || '操作失败');
            }
          })
          .finally(() => {
            this.editLoading = false;
          });
      });
    },
    /** 读取部门组织类型 */
    getDeptOrgType(dept) {
      if (!dept) return '';
      return String(dept.DeptOrgType != null ? dept.DeptOrgType : dept.deptOrgType || '').toLowerCase();
    },
    getDeptId(dept) {
      if (!dept) return '';
      return normalizeDeptId(dept.Id != null ? dept.Id : (dept.id != null ? dept.id : dept.value));
    },
    getDeptPid(dept) {
      if (!dept) return '';
      return normalizeDeptId(dept.Pid != null ? dept.Pid : dept.pid);
    },
    getDeptName(dept) {
      if (!dept) return '';
      return dept.Name || dept.name || dept.label || '';
    },
    /** 加载学校下全部子部门（扁平列表） */
    async ensureEditDeptList() {
      if (!this.SchoolDepartmentId) return;
      if (this.editDeptLoadedForSchool === this.SchoolDepartmentId && this.editDeptList.length) return;
      const res = await getSubDepartmentList({ pid: this.SchoolDepartmentId });
      if (!res.data.success) {
        this.$message.error(res.data.msg || '加载部门数据失败');
        return;
      }
      this.editDeptList = res.data.response || [];
      const map = {};
      this.editDeptList.forEach((d) => {
        map[this.getDeptId(d)] = d;
      });
      this.editDeptMap = map;
      this.editDeptLoadedForSchool = this.SchoolDepartmentId;
    },
    /** 判断部门是否在某祖先节点下 */
    isDescendantOf(deptId, ancestorId) {
      const targetId = normalizeDeptId(deptId);
      const ancestor = normalizeDeptId(ancestorId);
      if (!targetId || !ancestor) return false;
      let cur = this.editDeptMap[targetId];
      while (cur) {
        const id = this.getDeptId(cur);
        if (deptIdsEqual(id, ancestor)) return true;
        const pid = this.getDeptPid(cur);
        cur = pid ? this.editDeptMap[pid] : null;
      }
      return false;
    },
    /** 刷新年级/班级下拉选项 */
    refreshEditCascadeOptions() {
      const list = this.editDeptList || [];
      const campusTypes = ['campus', 'affiliateschool'];
      this.editCampusOptions = list
        .filter((d) => campusTypes.includes(this.getDeptOrgType(d)))
        .map((d) => ({ value: this.getDeptId(d), label: this.getDeptName(d) }));

      if (!this.editForm.campusId && this.editCampusOptions.length === 1) {
        this.editForm.campusId = this.editCampusOptions[0].value;
      }

      let gradePool = list.filter((d) => this.getDeptOrgType(d) === 'grade');
      if (this.editForm.campusId) {
        gradePool = gradePool.filter((g) => this.isDescendantOf(this.getDeptId(g), this.editForm.campusId));
      }
      this.editGradeOptions = gradePool.map((d) => ({ value: this.getDeptId(d), label: this.getDeptName(d) }));

      let classPool = list.filter((d) => this.getDeptOrgType(d) === 'class');
      if (this.editForm.gradeId) {
        classPool = classPool.filter((c) => this.isDescendantOf(this.getDeptId(c), this.editForm.gradeId));
      } else if (this.editForm.campusId) {
        classPool = classPool.filter((c) => this.isDescendantOf(this.getDeptId(c), this.editForm.campusId));
      }
      this.editClassOptions = classPool.map((d) => ({ value: this.getDeptId(d), label: this.getDeptName(d) }));
    },
    /** 根据班级 Id 反推校区、年级 */
    async syncEditCascadeFromClassId(classId) {
      const idStr = normalizeDeptId(classId);
      if (!idStr) return;
      this.editForm.classDepartmentId = idStr;
      let cur = this.editDeptMap[idStr];
      while (cur) {
        const type = this.getDeptOrgType(cur);
        const id = this.getDeptId(cur);
        if (type === 'grade') this.editForm.gradeId = id;
        if (type === 'campus' || type === 'affiliateschool') this.editForm.campusId = id;
        const pid = this.getDeptPid(cur);
        cur = pid ? this.editDeptMap[pid] : null;
      }
      this.refreshEditCascadeOptions();
      this.editForm.classDepartmentId = idStr;
    },
    /** 根据左侧树当前节点预填级联 */
    async initEditFormFromTree() {
      await this.ensureEditDeptList();
      const treeCtx = this.selectedTreeNode;
      if (!treeCtx || !treeCtx.data) {
        this.refreshEditCascadeOptions();
        return;
      }
      const { data, node } = treeCtx;
      const orgType = this.getDeptOrgType(data);
      const deptId = normalizeDeptId(data.value);

      if (orgType === 'class') {
        this.editForm.classDepartmentId = deptId;
        let n = node;
        while (n && n.data) {
          const t = this.getDeptOrgType(n.data);
          const id = normalizeDeptId(n.data.value);
          if (t === 'grade') this.editForm.gradeId = id;
          if (t === 'campus' || t === 'affiliateschool') this.editForm.campusId = id;
          n = n.parent;
        }
        await this.loadEditStudents(deptId);
      } else if (orgType === 'grade') {
        this.editForm.gradeId = deptId;
        let n = node;
        while (n && n.data) {
          const t = this.getDeptOrgType(n.data);
          if (t === 'campus' || t === 'affiliateschool') {
            this.editForm.campusId = normalizeDeptId(n.data.value);
            break;
          }
          n = n.parent;
        }
      } else if (orgType === 'campus' || orgType === 'affiliateschool') {
        this.editForm.campusId = deptId;
      }

      this.refreshEditCascadeOptions();
    },
    onEditCampusChange() {
      this.editForm.gradeId = null;
      this.editForm.classDepartmentId = null;
      this.editForm.studentInfoId = null;
      this.editStudentOptions = [];
      this.refreshEditCascadeOptions();
    },
    onEditGradeChange() {
      this.editForm.classDepartmentId = null;
      this.editForm.studentInfoId = null;
      this.editStudentOptions = [];
      this.refreshEditCascadeOptions();
    },
    async onEditClassChange(classId) {
      this.editForm.studentInfoId = null;
      this.editStudentOptions = [];
      if (classId) {
        await this.loadEditStudents(classId);
      }
    },
    /** 加载班级学生列表 */
    async loadEditStudents(classDepartmentId) {
      if (!classDepartmentId) return;
      this.editStudentLoading = true;
      try {
        const students = await this.fetchClassStudents(classDepartmentId);
        this.editStudentOptions = students.map((s) => ({
          id: Number(s.id != null ? s.id : s.Id),
          stuName: s.stuName || s.StuName || '',
          stuCode: s.stuCode || s.StuCode || '',
        }));
      } finally {
        this.editStudentLoading = false;
      }
    },
    // 打开导入弹窗
    ImportCensus() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择班级');
        return;
      }
      if (!this.semesterOptions.length) {
        this.$message.warning('当前学校暂无学期，请先配置学期');
        return;
      }
      this.resetImportDialog();
      this.importDialogVisible = true;
    },
    /** 重置导入弹窗状态 */
    resetImportDialog() {
      this.importActiveTab = 'download';
      this.importSemesterId = null;
      this.importOutputs = [];
      this.importPreviewPage = 1;
      this.importPreviewPageSize = 20;
      this.importFileList = [];
      if (this.$refs.importUpload) {
        this.$refs.importUpload.clearFiles();
      }
    },
    /** 拉取指定班级全部学生 */
    async fetchClassStudents(departmentId) {
      const deptId = departmentId || this.DepartmentId;
      if (!deptId) return [];
      const pageSize = 500;
      let page = 1;
      let allStudents = [];
      let total = 0;
      do {
        const res = await getStudentInfoListPage({
          page,
          departmentId: deptId,
          intPageSize: pageSize,
        });
        if (!res.data.success) {
          throw new Error(res.data.msg || '获取学生列表失败');
        }
        const batch = res.data.response.data || [];
        total = res.data.response.dataCount || 0;
        allStudents = allStudents.concat(batch);
        page += 1;
      } while (allStudents.length < total);
      return allStudents;
    },
    /** 生成导入模板工作表，学生ID 强制为文本避免精度丢失 */
    buildImportTemplateSheet(students) {
      const aoa = [['学生ID', '学生姓名', '表彰称号', '备注']];
      students.forEach((s) => {
        const studentId = s.id != null ? s.id : s.Id;
        const studentName = s.stuName || s.StuName || '';
        aoa.push([String(studentId), studentName, '', '']);
      });
      const ws = utils.aoa_to_sheet(aoa);
      for (let r = 1; r < aoa.length; r += 1) {
        const cellRef = utils.encode_cell({ r, c: 0 });
        if (ws[cellRef]) {
          ws[cellRef].t = 's';
          ws[cellRef].v = String(aoa[r][0]);
          ws[cellRef].z = '@';
        }
      }
      ws['!cols'] = [{ wch: 20 }, { wch: 12 }, { wch: 20 }, { wch: 16 }];
      return ws;
    },
    /** 解析 Excel 中的学生ID */
    parseImportStudentId(rawId) {
      if (rawId == null || rawId === '') return '';
      if (typeof rawId === 'number') return String(Math.trunc(rawId));
      return String(rawId).trim();
    },
    /** 下载导入模板（预填本班学生） */
    async downloadImportTemplate() {
      if (!this.importSemesterId) {
        this.$message.warning('请先选择学期');
        return;
      }
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择班级');
        return;
      }
      this.importTemplateLoading = true;
      try {
        const students = await this.fetchClassStudents();
        if (!students.length) {
          this.$message.warning('当前班级暂无学生，无法生成模板');
          return;
        }
        const semester = this.semesterOptions.find((s) => (s.Id || s.id) === this.importSemesterId);
        const semesterName = semester ? (semester.SemesterName || semester.semesterName || '') : '';
        const className = this.currentDeptName || '班级';
        const ws = this.buildImportTemplateSheet(students);
        const wb = { SheetNames: ['模板'], Sheets: { 模板: ws } };
        const fileName = semesterName
          ? `表彰称号导入模板_${className}_${semesterName}.xlsx`
          : `表彰称号导入模板_${className}.xlsx`;
        writeFile(wb, fileName);
        this.$message.success(`模板已下载，共 ${students.length} 名学生，请填写表彰称号后上传`);
      } catch (err) {
        this.$message.error(err.message || '模板生成失败');
      } finally {
        this.importTemplateLoading = false;
      }
    },
    /** 选择导入文件 */
    onImportFileChange(file) {
      const rawFile = file.raw;
      if (!rawFile) return;
      if (!/\.(xls|xlsx)$/i.test(rawFile.name)) {
        this.$message.error('请上传 xls 或 xlsx 格式的文件');
        this.importFileList = [];
        return;
      }
      this.importFileList = [file];
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const workbook = read(ev.target.result, { type: 'binary' });
          const wsname = workbook.SheetNames[0];
          const ws = utils.sheet_to_json(workbook.Sheets[wsname]);
          this.importOutputs = ws.map((row) => ({
            studentInfoId: this.parseImportStudentId(
              row['学生ID'] != null && row['学生ID'] !== ''
                ? row['学生ID']
                : (row['学生Id'] != null && row['学生Id'] !== ''
                  ? row['学生Id']
                  : row['studentInfoId'])
            ),
            studentName: String(row['学生姓名'] || '').trim(),
            honorTitle: String(row['表彰称号'] || '').trim(),
            remark: String(row['备注'] || '').trim(),
          })).filter((r) => r.honorTitle);
          if (this.importOutputs.length === 0) {
            this.$message.warning('未解析到已填写表彰称号的数据，请在模板中填写「表彰称号」列');
            this.importFileList = [];
            return;
          }
          this.importPreviewPage = 1;
          this.importActiveTab = 'preview';
          this.$message.success(`已解析 ${this.importOutputs.length} 条待导入数据，请预览确认`);
        } catch (err) {
          this.$message.error('文件解析失败，请检查格式');
          this.importFileList = [];
        }
      };
      fileReader.readAsBinaryString(rawFile);
    },
    onImportFileRemove() {
      this.importFileList = [];
      this.importOutputs = [];
      if (this.importActiveTab === 'preview') {
        this.importActiveTab = 'upload';
      }
    },
    // 删除预览行（pageIndex 为当前页内索引）
    removeImportRow(pageIndex) {
      const index = (this.importPreviewPage - 1) * this.importPreviewPageSize + pageIndex;
      this.importOutputs.splice(index, 1);
      if (!this.importOutputs.length) {
        this.importActiveTab = 'upload';
        return;
      }
      const maxPage = Math.ceil(this.importOutputs.length / this.importPreviewPageSize) || 1;
      if (this.importPreviewPage > maxPage) {
        this.importPreviewPage = maxPage;
      }
    },
    handleImportPreviewPageChange(val) {
      this.importPreviewPage = val;
    },
    handleImportPreviewSizeChange(val) {
      this.importPreviewPageSize = val;
      this.importPreviewPage = 1;
    },
    /** 统一导入结果字段（兼容 PascalCase / camelCase） */
    normalizeImportResult(raw) {
      const d = raw || {};
      return {
        successCount: d.successCount != null ? d.successCount : (d.SuccessCount || 0),
        failCount: d.failCount != null ? d.failCount : (d.FailCount || 0),
        failReasons: d.failReasons || d.FailReasons || [],
      };
    },
    // 提交导入
    submitImport() {
      if (!this.importSemesterId) {
        this.$message.warning('请选择学期');
        return;
      }
      if (this.importOutputs.length === 0) {
        this.$message.warning('没有可导入的数据');
        return;
      }
      this.importLoading = true;
      const params = {
        schoolDepartmentId: this.SchoolDepartmentId,
        departmentId: this.DepartmentId,
        semesterId: this.importSemesterId,
        rows: this.importOutputs,
      };
      importStudentHonorTitleBatch(params)
        .then((res) => {
          if (res.data.success) {
            this.importDialogVisible = false;
            this.importResult = this.normalizeImportResult(res.data.response);
            this.importResultVisible = true;
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || '导入失败');
          }
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
    // 时间格式化
    formatDate(val) {
      if (!val) return '';
      const d = new Date(val);
      if (isNaN(d.getTime())) return val;
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.import-tabs {
  box-shadow: none;
}

.import-tab-pane {
  padding: 8px 4px 4px;
}

.import-download-box {
  text-align: center;
  padding: 28px 16px 20px;
}

.import-download-icon {
  font-size: 44px;
  color: var(--btn-primary, #2563eb);
  margin-bottom: 12px;
}

.import-tip {
  font-size: 14px;
  color: #606266;
  margin: 0 0 8px;
  line-height: 1.6;
}

.import-tip-sub {
  font-size: 13px;
  color: #909399;
  margin: 0 0 16px;
}

.import-step-tip {
  margin-top: 12px;
  padding: 10px 12px;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 13px;
  color: #909399;
}

.import-step-tip i {
  margin-right: 6px;
  color: var(--btn-primary, #2563eb);
}

.import-preview-summary {
  margin: 0 0 12px;
  font-size: 14px;
  color: #606266;
}

.import-preview-pagination {
  margin-top: 12px;
  text-align: right;
}
</style>
